import { Button, Result } from 'antd';
import { useNavigate } from 'react-router';

export function NotFound() {
  const navigate = useNavigate();
  return <Result status="404" title="페이지를 찾을 수 없습니다" extra={<Button onClick={() => navigate('/')}>대시보드로</Button>} />;
}
